import { Can } from "@/casl-provider";
import { CasaviContactWhitelistTable } from "@/components/data-table/predefined/casavi-contact-whitelist-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { getCasaviContactWhitelistColumns } from "@/modules/casavi/_helpers/table-columns";
import { useTranslation } from "react-i18next";

const DEFAULT_PAGE_SIZE = 100;

export function CasaviContactWhitelistView() {
  const { t } = useTranslation(["casavi", "common"]);

  return (
    <Can I="read" a="CasaviContactWhitelist">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("casavi:ContactWhitelist")}
        subTitle={t("casavi:CasaviContactWhitelistDescription")}
      >
        <CasaviContactWhitelistTable
          columns={getCasaviContactWhitelistColumns()}
          pageSize={DEFAULT_PAGE_SIZE}
          createButtonLink="~/cas/contact-whitelist/create"
        />
      </CenteredLayout>
    </Can>
  );
}
